import React from 'react';
import BackHeader from '../BackHeader';
import NavigationBar from '../NavigationBar';

const CartPageSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <BackHeader title="장바구니" />

      <main className="px-4 pb-[128px]">
        {/* Restaurant Info Skeleton */}
        <div className="py-4 bg-white mb-4 border-b border-gray-200 cursor-pointer -mx-4 px-4">
          <div className="h-6 bg-gray-200 rounded animate-pulse w-48 flex items-center">
            <div className="w-5 h-5 bg-gray-300 rounded ml-auto"></div>
          </div>
        </div>

        {/* Cart Items Skeleton */}
        <div className="divide-y divide-gray-200">
          {/* Item 1 */}
          <div className="py-4 flex items-start">
            <div className="w-20 h-20 rounded-md bg-gray-200 animate-pulse flex-shrink-0"></div>
            <div className="ml-3 flex-grow min-w-0">
              <div className="flex justify-between items-start">
                <div className="h-6 bg-gray-200 rounded animate-pulse w-32 mb-2"></div>
                <div className="w-5 h-5 bg-gray-200 rounded animate-pulse"></div>
              </div>
              <div className="flex items-center justify-between mt-2">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-gray-200 rounded-md animate-pulse"></div>
                  <div className="mx-4 h-4 bg-gray-200 rounded animate-pulse w-6"></div>
                  <div className="w-8 h-8 bg-gray-200 rounded-md animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Item 2 */}
          <div className="py-4 flex items-start">
            <div className="w-20 h-20 rounded-md bg-gray-200 animate-pulse flex-shrink-0"></div>
            <div className="ml-3 flex-grow min-w-0">
              <div className="flex justify-between items-start">
                <div className="h-6 bg-gray-200 rounded animate-pulse w-40 mb-2"></div>
                <div className="w-5 h-5 bg-gray-200 rounded animate-pulse"></div>
              </div>
              <div className="flex items-center justify-between mt-2">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-gray-200 rounded-md animate-pulse"></div>
                  <div className="mx-4 h-4 bg-gray-200 rounded animate-pulse w-6"></div>
                  <div className="w-8 h-8 bg-gray-200 rounded-md animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Order Summary Skeleton */}
        <div className="bg-white p-4 rounded-lg shadow-sm mb-4">
          <div className="h-6 bg-gray-200 rounded animate-pulse w-24 mb-3"></div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
            </div>
            <div className="flex justify-between">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
            </div>
            <div className="border-t pt-2 mt-2 flex justify-between">
              <div className="h-5 bg-gray-200 rounded animate-pulse w-12"></div>
              <div className="h-6 bg-gray-200 rounded animate-pulse w-24"></div>
            </div>
          </div>
        </div>

        {/* Minimum Order Notice Skeleton */}
        <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200 mb-4">
          <div className="flex items-start">
            <div className="w-5 h-5 bg-yellow-200 rounded animate-pulse mt-0.5 mr-2 flex-shrink-0"></div>
            <div className="flex-1">
              <div className="h-4 bg-yellow-200 rounded animate-pulse w-full mb-1"></div>
              <div className="h-3 bg-yellow-200 rounded animate-pulse w-3/4"></div>
            </div>
          </div>
        </div>
      </main>

      {/* Fixed Bottom Button */}
      <div className="fixed bottom-[60px] left-1/2 transform -translate-x-1/2 bg-white shadow-top p-4 z-20 max-w-mobile w-full">
        <div className="w-full">
          <div className="h-12 bg-gray-200 rounded-md animate-pulse"></div>
        </div>
      </div>

      <NavigationBar />
    </div>
  );
};

export default CartPageSkeleton; 